<template>
	<div>
		<v-layout
			row wrap
			align-center
			justify-end
			class="print-no-show"
		>
			<v-flex xs6>
				<v-layout wrap justify-end>
					<v-flex xs1 text-xs-right>
						<v-btn
							icon
							v-tooltip:left="{ html: 'Descargar tarjeta de embarque' }"
							@click="downloadCardTravel"
						>
							<v-icon>card_travel</v-icon>
						</v-btn>
					</v-flex>
					<v-flex xs1 text-xs-right>
						<v-btn
							icon
							v-tooltip:left="{ html: 'Imprimir detalle de reserva' }"
							@click="print"
						>
							<v-icon>print</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap align-center mb-4>
			<v-flex xs5 text-xs-left pr-4>
				<v-layout row wrap class="card-detail">
					<v-flex xs12 pa-3>
						<label class="card-detail-label">
							{{ booking.summary.personalInformation.hotelName }}
						</label>
					</v-flex>
					<v-flex xs12 pa-0>
						<v-divider></v-divider>
					</v-flex>
					<v-flex xs7 px-3>
						<h3 class="card-detail-name">
							{{ booking.summary.personalInformation.name }}
							{{ booking.summary.personalInformation.lastName }}
						</h3>
					</v-flex>
					<v-flex xs12 pl-3 pr-4 py-0
						class="default-height">
						<span class="card-detail-comment"
							v-if="booking.summary.personalInformation.specialRequest">
							"{{ booking.summary.personalInformation.specialRequest }}"
						</span>
					</v-flex>
					<v-flex xs12 px-3>
						<v-divider class="card-detail-hr"></v-divider>
					</v-flex>
					<v-flex xs12 px-3 pb-2 class="card-detail-footer">
						<v-layout row wrap>
							<v-flex xs3>
								<label>Email:</label>
							</v-flex>
							<v-flex xs9 text-xs-right>
								<span>{{ booking.summary.personalInformation.email }}</span>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<label>Teléfono:</label>
							</v-flex>
							<v-flex xs9 text-xs-right>
								<span>+{{ booking.summary.personalInformation.phone }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs7 text-xs-left>
				<v-layout row wrap class="card-detail">
					<v-flex xs12 px-5 pt-3 pb-4>
						<v-layout row wrap>
							<v-flex xs4 pb-0>
								<label class="card-detail-label">
									Número de Reserva:
								</label>
							</v-flex>
							<v-flex xs8 pb-0 text-xs-right>
								<span>{{ booking.numReservation }}</span>
							</v-flex>
							<v-flex xs4 pb-0>
								<label class="card-detail-label">
									Reserve Number GDS:
								</label>
							</v-flex>
							<v-flex xs8 pb-0 text-xs-right>
								<span>{{ booking.code }}</span>
							</v-flex>
							<v-flex xs4 pb-0>
								<label class="card-detail-label">
									Estado de la Reserva:
								</label>
							</v-flex>
							<v-flex xs8 pb-0 text-xs-right>
								<span>{{ bookingStateName }}</span>
							</v-flex>
							<v-flex xs4 pb-0>
								<label class="card-detail-label">
									Sitio web:
								</label>
							</v-flex>
							<v-flex xs8 pb-0 text-xs-right>
								<span>Sitio Web</span>
							</v-flex>
							<v-flex xs4 pb-0>
								<label class="card-detail-label">
									Fecha de Reserva:
								</label>
							</v-flex>
							<v-flex xs8 pb-0 text-xs-right>
								<span>{{ booking.bookingDate | parseDate('DD/MM/YYYY HH:mm:ss') }} (Extranet TimeZone)</span>
							</v-flex>
							<v-flex xs4 pb-0>
								<label class="card-detail-label">
									Última actualización:
								</label>
							</v-flex>
							<v-flex xs8 pb-0 text-xs-right>
								<span>{{ booking.updatedAt | parseDate('DD/MM/YYYY HH:mm:ss') }} (Hotel TimeZone)</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 px-5 py-2 class="card-detail-total">
						<v-layout row wrap>
							<v-flex xs6 py-2>
								<label>Venta Mensual</label>
							</v-flex>
							<v-flex xs6 py-2 text-xs-right>
								<label>{{ booking.total | round }} {{ booking.summary.promotion.iso_currency }}</label>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap mb-4>
			<v-flex xs12 px-0 pb-0>
				<table
					border="0"
					cellspacing="0"
					cellpadding="0"
					class="card-detail-table"
					width="100%">
					<thead>
						<tr>
							<th
								v-for="column in columns"
								:key="column.id">
								{{ column.name }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>{{ booking.summary.roomName }}</td>
							<td>{{ booking.guests }}</td>
							<td>{{ booking.summary.booking.adults }}</td>
							<td>{{ booking.summary.booking.childrens }}</td>
							<td>{{ booking.summary.booking.checkIn | parseDate }}</td>
							<td>{{ booking.summary.booking.checkOut | parseDate }}</td>
							<td>{{ booking.stateName }}</td>
							<td>{{ booking.total | round }} {{ booking.summary.promotion.iso_currency }}</td>
						</tr>
					</tbody>
				</table>
			</v-flex>
			<v-flex xs12 px-0 class="card-detail-info">
				<v-layout row wrap pt-2>
					<v-flex xs2 pl-2 text-xs-left>
						<label>Observaciones:</label>
					</v-flex>
					<v-flex xs10 pr-2 text-xs-left>
						<span>{{ booking.observations }}</span>
					</v-flex>
				</v-layout>
				<v-layout row wrap
					class="card-detail-rates"
					v-if="booking.summary.services">
					<v-flex xs12 px-2 text-xs-left>
						<label>Servicios adicionales:</label>
					</v-flex>
					<v-flex xs12 px-2 mb-3>
						<table
							border="0"
							cellspacing="0"
							cellpadding="0"
							width="100%">
							<thead>
								<tr>
									<th>Nombre</th>
									<th>Cantidad</th>
									<th>Precio</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="service in booking.summary.services"
									:key="service.id">
									<td>{{ service.languages.es.name }}</td>
									<td>{{ service.quantity }}</td>
									<td>{{ service.total | round }} {{ service.iso_currency }}</td>
								</tr>
								<tr>
									<td>{{ booking.summary.earlyCheckIn.languages.es.name }}</td>
									<td>{{ booking.summary.earlyCheckIn.quantity }}</td>
									<td>{{ booking.summary.earlyCheckIn.total | round }} {{ booking.summary.earlyCheckIn.iso_currency }}</td>
								</tr>
								<tr>
									<td>{{ booking.summary.lateCheckOut.languages.es.name }}</td>
									<td>{{ booking.summary.lateCheckOut.quantity }}</td>
									<td>{{ booking.summary.lateCheckOut.total | round }} {{ booking.summary.lateCheckOut.iso_currency }}</td>
								</tr>
							</tbody>
						</table>
					</v-flex>
				</v-layout>
				<v-layout row wrap class="card-detail-rates">
					<v-flex xs12 px-2 text-xs-left>
						<label>Tarifas:</label>
					</v-flex>
					<v-flex xs12 px-2>
						<table
							border="0"
							cellspacing="0"
							cellpadding="0"
							width="100%">
							<thead>
								<tr>
									<th>Habitación:</th>
									<th>Tarifa</th>
									<th>Día</th>
									<th>Precio</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="rate in booking.summary.ratesPerDates"
									:key="rate.id">
									<td>{{ booking.summary.promotion.name }}</td>
									<td>{{ rate.date_reservation | parseDate }}</td>
									<td>{{ rate.price | round }} {{ rate.iso_currency }}</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 px-0 pb-0>
				<table
					border="0"
					cellspacing="0"
					cellpadding="0"
					class="card-detail-table card-footer-table"
					width="100%">
					<thead>
						<tr>
							<th colspan="2">Datos de la tarjeta</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Nombre del titular de la tarjeta:</td>
							<td>{{ booking.summary.personalInformation.name }}
								{{ booking.summary.personalInformation.lastName }}</td>
						</tr>
						<tr>
							<td>Número de la tarjeta:</td>
							<td>{{ booking.summary.personalInformation.payment.cardNumber }}</td>
						</tr>
						<tr>
							<td>Tipo de tarjeta:</td>
							<td>{{ booking.summary.personalInformation.payment.cardType }}</td>
						</tr>
						<tr>
							<td>Fecha de expiración:</td>
							<td>{{booking.summary.personalInformation.payment.month}} / {{booking.summary.personalInformation.payment.year}}</td>
						</tr>
					</tbody>
				</table>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import { parseDate, round } from '@/shared/filters';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';

	const helperMethods = helper.methods;

	function created() {
		this.loadStates();
		this.loadData();
	}

	function bookingStateName() {
		const stateNumber = Number(this.booking.bookingState);
		const returnState = this.states.find(state => state.id === stateNumber) || {};
		return returnState.name;
	}

	async function downloadCardTravel() {
		const baseUrl = process.env.PMS_URL;
		const typeDocumentCode = 'registerCard';
		const name = `TARJETA-DE-EMBARQUE${this.bookingCode}`;
		const responseType = 'blob';
		const cardModel = { details: [{}] };
		const response = await this.$http.post(`${baseUrl}/booking/${this.bookingCode}/report/${typeDocumentCode}`,
			cardModel, { responseType });
		const blob = helperMethods.generateBlob(response.bodyBlob);
		helperMethods.showDownloadDialog(blob, name, 'pdf');
	}

	async function loadData() {
		const { data: booking } = await this.$http.get(`${process.env.PMS_URL}/bookings/${this.$route.query.codeBooking}`);
		const responseData = booking.data;
		const numTotal = responseData.femaleNum ? Number(responseData.femaleNum) : 0;
		responseData.guests = numTotal + responseData.maleNum ? Number(responseData.maleNum) : 0;
		const defaultLang = responseData.summary.language;
		responseData.employee.data = responseData.employee.data ? responseData.employee.data
			: {};
		responseData.channel = responseData.channel ? responseData.channel : {};
		responseData.channel.data = responseData.channel.data ? responseData.channel.data
			: {};
		responseData.channel.data.questions = responseData.channel.data.questions ?
			responseData.channel.data : {};
		responseData.summary.personalInformation.payment =
			responseData.summary.personalInformation.payment ?
			responseData.summary.personalInformation.payment : {};
		responseData.summary.promotion.name = responseData.summary.promotion[defaultLang] ?
			responseData.summary.promotion[defaultLang].name :
			responseData.summary.promotion.name;
		this.booking = responseData;
	}

	async function loadStates() {
		const { data: states } = await this.$http.get(`${process.env.PMS_URL}/booking/status`);
		this.states = states.data;
	}

	function print() {
		window.print();
	}

	function data() {
		return {
			booking: {
				channel: {
					data: {
						questions: {},
					},
				},
				employee: {
					data: {},
				},
				summary: {
					booking: {},
					personalInformation: {
						payment: {},
					},
					promotion: {},
					ratesPerDates: [],
				},
			},
			columns: [
				{ id: 1, name: 'Habitación' },
				{ id: 2, name: '# Huéspedes' },
				{ id: 3, name: 'Adultos' },
				{ id: 4, name: 'Niños' },
				{ id: 5, name: 'Fecha de llegada' },
				{ id: 6, name: 'Fecha de Partida' },
				{ id: 7, name: 'Estado' },
				{ id: 8, name: 'Precio' },
			],
			model: {
				cardholder: '',
				cardNumber: '',
				cardType: '',
				comment: '',
				email: '',
				lastname: '',
				name: '',
				phone: '',
			},
			states: [],
		};
	}

	export default {
		name: 'detail-guest',
		created,
		computed: {
			bookingStateName,
		},
		data,
		filters: {
			parseDate,
			round,
		},
		methods: {
			downloadCardTravel,
			loadData,
			loadStates,
			print,
		},
		mixins: mixin,
	};
</script>

<style lang="scss" scoped>
	.card-detail {
		background-color: white;
		min-height: 275px;

		&-label {
			color: map-get($colors, dark);
			font-family: map-get($fonts, medium);
			font-size: 14px;
			font-weight: normal;
		}

		&-name {
			color: map-get($colors, dark);
			font-family: map-get($fonts, regular);
			font-size: 30px;
			font-weight: normal;
			line-height: normal;
			margin-bottom: 0px;
		}

		&-comment {
			color: map-get($colors, realtime-label);
			font-family: Arial, Helvetica, sans-serif;
			font-size: 12px;
			font-style: oblique;
			line-height: 0;
		}

		&-hr {
			background-color: map-get($colors, card-detail-hr);
			height: 2px;
		}

		&-footer {
			label {
				color: map-get($colors, dark);
				font-family: map-get($fonts, medium);
				font-size: 16px;
				font-weight: normal;
			}

			span {
				color: map-get($colors, dark);
				font-family: map-get($fonts, regular);
				font-size: 14px;
				font-weight: normal;
			}
		}

		&-total {
			background-color: map-get($colors, dark);
			color: white;

			label {
				font-family: map-get($fonts, semibold);
				font-size: 14px;
				font-weight: normal;
			}
		}

		&-table {
			th {
				background-color: map-get($colors, color-selected-item);
				color: white;
				font-weight: normal;
				height: 42px;
				padding: 0px 0px 0px 21px;
				text-align: left;
			}

			td {
				background-color: white;
				border-bottom: 1px solid map-get($colors, card-detail-table-border);
				color: map-get($colors, color-selected-item);
				font-family: map-get($fonts, medium);
				font-size: 14px;
				max-width: 188px;
				padding: 14px 0px 14px 21px;
				text-align: left;
			}

			&.card-footer-table {
				td {
					border-bottom: 0px;
					max-width: none;
					padding: 9px 0px 9px 21px;

					&:first-child {
						width: 290px;
					}

					&:last-child {
						color: map-get($colors, realtime-label);
						font-family: map-get($fonts, regular);
						font-size: 14px;
					}
				}
			}
		}

		&-info {
			background-color: white;
			padding: 16px 21px 26px !important;

			label {
				color: map-get($colors, color-selected-item);
				font-family: map-get($fonts, medium);
				font-size: 14px;;
			}

			span {
				color: map-get($colors, realtime-label);
				font-family: map-get($fonts, regular);
				font-size: 14px;
			}
		}

		&-rates {
			label {
				color: map-get($colors, dark);
				font-family: map-get($fonts, medium);
				font-size: 14px;
			}

			table {
				th {
					background-color: map-get($colors, th-table-rates);
					color: white;
					font-weight: normal;
					height: 30.5px;
					padding: 0px 0px 0px 16px;
					text-align: left;
				}

				td {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: 14px;
					padding: 6px 0px 6px 16px;
					text-align: left;
				}
			}
		}
	}

	.default-height {
		height: 63px;
	}
</style>


// WEBPACK FOOTER //
// detail-guest.vue?9aede22e